import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Card, Collapse, List, Progress, Space, Tooltip } from 'antd';

import { CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';

import './Notifications.less';

const propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
};
const defaultProps = {
  notifications: [],
  className: '',
};

export default class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { notifications, rootContainer } = this.props;

    return (
      <div
        className="oc-fm--notifications oc-fm--file-navigator__notifications"
        onContextMenu={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <Card bordered={false} bodyStyle={{ margin: '0', padding: '0' }}>
          {notifications.map((notification, i) => {
            return (
              <Collapse key={`notif-${i}`} defaultActiveKey={['1']}>
                <Collapse.Panel
                  className="fm_notif_item_collapse"
                  collapsible={notification.minimizable}
                  header={notification.title}
                  key="1"
                  extra={
                    <CloseOutlined
                      onClick={(event) => {
                        event.stopPropagation();
                        notification.onHide();
                      }}
                    />
                  }
                >
                  <List
                    size="small"
                    bordered
                    dataSource={notification.children}
                    renderItem={(item) => (
                      <List.Item>
                        {item.element && item.element.elementType === 'NotificationProgressItem' ? (
                          <>
                            <Space>
                              <div>{item.element.elementProps && item.element.elementProps.icon ? item.element.elementProps.icon.icon : null}</div>
                              <div
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '190px',
                                }}
                              >
                                {item.element.elementProps ? item.element.elementProps.title : null}
                              </div>
                            </Space>
                            {item.element.elementProps && item.element.elementProps.message && !item.element.elementProps.isSuccess? (
                              <Tooltip getPopupContainer={rootContainer} title={item.element.elementProps.message}>
                                <InfoCircleOutlined />
                              </Tooltip>
                            ) : (
                              <div>
                                {item.element.elementProps ? (
                                  <Progress type="circle" percent={item.element.elementProps.progress} width={28} strokeWidth={9} />
                                ) : null}
                              </div>
                            )}
                          </>
                        ) : null}
                      </List.Item>
                    )}
                  />
                </Collapse.Panel>
              </Collapse>
            );
          })}
        </Card>
      </div>
    );
  }
}

Notifications.propTypes = propTypes;
Notifications.defaultProps = defaultProps;
